import "../../app/styles/login.css?__remix_sideEffect__";

import React, { useState, useEffect } from "react";
import OTPInput from "react-otp-input";
import { useSnackbar } from "notistack";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useStateRef from "react-usestateref";
import {
  getUserDetails,
  sendOTP,
  sendWaitListUserDetails,
  validateOtp } from
"../api/login-service";
import moment from "moment";
import { useRoot } from "../context/RootContext";
import { saveEvent } from "../network/TutorApiService";
import { EVENTS_LIST, setCookie } from "../utils/TutorConstants";
import {
  handleNavigateNewTab,
  isEmptyOrNull,
  isNotEmptyOrNull,
  storeImage,
  tutorString,
  urlString } from
"../utils/common-utils";
import Waitlisting from "../components/molecules/waitListing/Waitlisting";
import {
  Radio,
  RadioGroup,
  Stack,
  Box,
  Text,
  Checkbox,
  Image,
  Button,
  VStack,
  useBreakpointValue,
  HStack } from
"@chakra-ui/react";
import infoCircle from "../assets/home/infoCircle.svg";
import Bot from "../components/atoms/icons/botWithShadow.svg";
import Coschool from "../components/atoms/icons/logoWithBlackText.svg";
import CoschoolWhite from "../assets/svgs/coschoolWhite.svg";
import { useToast } from "@chakra-ui/react";
import { status } from "../utils/LearningPathUtils";
import { getCurriculum, getGrades } from "../network/LearnApiService";
import WelcomeLottie from "../components/atoms/icons/welcomeScreen.json";
import LottiePlayer from "../components/organisms/wall/LottiePlayer";
import { StorageService } from "../utils/StorageUtils";
import CustomToolTip from "../components/atoms/chakraHelpers/customToolTip";
import loginLeftImage from "../assets/svgs/loginLeftImage.svg";
import pkg from "@inrscr/coschool-ui-components";
import WifiDownImg from "../assets/svgs/wifiDownIcon.svg";

export let loader = async () => {
  return { type: "login" };
};

export default function Login() {
  const { PrivacyTouchPoint } = pkg;
  const toast = useToast();
  const [checked, setChecked] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const {
    setIsAuthenticated,
    setIsTutor,
    isTutor,
    setSelectedIndex,
    setIsStudentAppMapping,
    setUserDetails,
    setRegistrationStatus
  } = useRoot();
  const isMobile = useBreakpointValue(
    {
      base: true,
      sm: true,
      md: true,
      lg: false,
      xl: false
    },
    { fallback: "false" }
  );
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoader, setIsLoader] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [isWaitlisted, setIsWaitlisted] = useState(false);
  const [value, setValue] = React.useState("1");
  const [selectedGrade, setSelectedGrade] = React.useState();
  const [grades, setGrades] = useState([]);
  const [isOtherSelected, setIsOtherSelected, isOtherSelectedRef] =
  useStateRef(false);
  const [termsChecked, setTermsChecked, termsCheckedRef] = useStateRef(false);
  const [errorResponse, setErrorResponse, errorResponseRef] = useStateRef("");
  const [isStandaloneUser, setIsStandaloneUser, isStandaloneUserRef] =
  useStateRef(false);
  const otpStyle = {
    display: "flex",
    justifyContent: "center",
    gap: "10px"
  };
  const inputStyle = {
    width: "40px",
    height: "40px",
    border: "2px solid #130159",
    borderRadius: "4px",
    fontSize: "20px",
    textAlign: "center"
  };

  const [userInfo, setUserInfo, userInfoRef] = useStateRef({
    country_code: "+91",
    mobile: "",
    otp: "",
    step: 2,
    toast_keys: [],
    name: ""
  });
  const handleLinkClick = () => {
    window.location.href = "https://www.coschool.ai/";
  };

  const handleTerms = () => {
    window.location.href = "https://www.coschool.ai/about-us";
  };


  const callUserDetailsSafely = (userDetails) => {
    try {
      // Check if userDetails is already an object or a string
      if (userDetails) {
        let parsedDetails;

        parsedDetails =
        typeof userDetails === "object" ?
        userDetails :
        JSON.parse(userDetails);

        // Check if it has the required properties
        if (
        parsedDetails &&
        parsedDetails.userId &&
        parsedDetails.registrationStatus)
        {
          callGetUserDetails(
            parsedDetails.userId,
            parsedDetails.registrationStatus
          );
        } else {
          console.error("User details missing required properties");
        }
      } else {
        console.error("User details not provided");
      }
    } catch (error) {
      console.error("Error parsing user details:", error);
    }
  };

  useEffect(() => {
    const userDetails = StorageService.getItem("user_details");
    setIsStandaloneUser(window?.ENV?.IS_DEFAULT_STANDALONE == "true");
    if (isNotEmptyOrNull(userDetails)) {
      callUserDetailsSafely(userDetails);
    }
  }, []);

  const callGetUserDetails = async (userId, registrationStatus) => {
    const { success, data: userData } = await getUserDetails(
      userId,
      registrationStatus
    );
    if (success) {
      if (userData?.data?.registrationStatus === "2") {
        setUserInfo({
          country_code: "+91",
          mobile: "",
          otp: "",
          step: 2,
          toast_keys: [],
          name: ""
        });
      } else {
        checkRegistrationStatus(userData, true);
      }
    }
  };

  useEffect(() => {
    let interval = null;
    if (seconds > 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [seconds]);
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds.
    toString().
    padStart(2, "0")}`;
  };

  const handleShowToast = (status, type) => {
    toast({
      title: type,
      position: "top",
      description: status,
      status: type,
      duration: 1500,
      isClosable: true,
      containerStyle: {
        color: "#fff"
      }
    });
  };

  const handleStateChange = (key, value) => {
    // For mobile, ensure the value is numeric and does not exceed 10 digits
    if (key === "mobile" && !/^\d{0,10}$/.test(value)) {
      return;
    }
    let existingData = { ...userInfoRef?.current };
    existingData[key] = value;
    setUserInfo(existingData);
  };

  useEffect(() => {
    let timeoutId;
    if (userInfoRef?.current?.toast_keys > 0) {
      timeoutId = setTimeout(() => {
        for (let i = 0; i < userInfoRef?.current?.toast_keys?.length; i++) {
          let key = userInfoRef?.current?.toast_keys[i];
          closeSnackbar(key);
        }
        handleStateChange("toast_keys", []);
      }, 1500);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [userInfo]);
  const step_one = () => {
    return (
      <React.Fragment>
        <div className={"title-text"} id="step-one-title">
          👋 Hey There! I am Vin
        </div>
        <div className="info-text" id="step-one-sub-text">
          Your friendly Ai helper, ready to make learning super fun! . Let’s get
          stay connected on this awesome learning journey.
        </div>
        <div
          className="btn"
          onClick={() => {
            handleStateChange("step", 2);
          }}
          id="step-one-btn">

          Let's go
        </div>
      </React.Fragment>);

  };


  const step_two = () => {
    let mobile = userInfoRef?.current.mobile;
    let isValid = mobile?.trim()?.length == 10;
    return (
      <React.Fragment>
        <div className="right-title-text" id="step-two-title">
          {isStandaloneUserRef.current ?
          "Enter Mobile Number" :
          "Enter Login Id"}
        </div>
        {/* <div className="right-sub-text">
           Vin's ready to send you a code. What's your phone number?
          </div> */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px"
          }}
          id="step-two-mobile-input-container">

          <div className="mobile-container" id="step-two-mobile-container">
            {/* <div className="country-code">+91</div> */}
            <input
              className="mobile-input"
              id="step-two-mobile-input"
              value={mobile}
              onChange={(e) => {
                const value = e.target.value;
                // Ensure the value is numeric and does not exceed 10 digits
                if (/^\d{0,10}$/.test(value)) {
                  handleStateChange("mobile", value);
                }
              }}
              onKeyDown={(e) => {
                // Capture the Enter key event
                if (e.key === "Enter" && checked) {
                  isValid && !isLoader && handleSendOtp(true);
                }
              }}
              type="tel"
              inputMode="numeric"
              maxLength={10} // This ensures that input length cannot exceed 10 digits
            />
          </div>
          {/* <CustomToolTip
             data={
               "Please refer to the welcome email or your school ID card to enter your enrollment or Student ID number here. "
             }
             marginLeft={"20px"}
             variant={"Login"}
             icon={info}
            /> */}
        </div>
        <PrivacyTouchPoint
          checked={checked}
          toggleChecked={() => {setChecked(!checked);}}
          handleNavigatePrivacy={() => {handleNavigateNewTab(`${urlString}/privacy`);}} />

        <Button
          className={`btn ${isValid && checked ? "" : "btn-disable"}`}
          onClick={() => {
            isValid && checked && !isLoader && handleSendOtp(true);
          }}
          isLoading={isLoader}
          id="step-two-send-otp-btn">

          Send OTP
        </Button>
      </React.Fragment>);

  };

  const portalMissMatch = () => {
    return (
      <Box
        style={{
          textAlign: "center",
          width: "100%",
          alignItems: "center"
        }}
        id="login-portal-mismatch">

        <Box
          style={{
            gap: "4px",
            textAlign: "center",
            width: "100%",
            height: "56px",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#FFDFDB"
          }}
          id="login-portal-mismatch-box">

          <Image paddingLeft={"10px"} src={infoCircle}></Image>
          <Text
            fontFamily={"poppins"}
            fontWeight={500}
            fontSize={"16px"}
            lineHeight={"24px"}
            textColor={"#130159"}
            paddingRight={"10px"}
            id="login-portal-mismatch-text">

            This account is associated with a school account
          </Text>
        </Box>
        <Text
          fontFamily={"poppins"}
          fontWeight={500}
          fontSize={"16px"}
          lineHeight={"24px"}
          textColor={"#130159"}
          paddingRight={"10px"}
          marginTop={"16px"}
          id="login-portal-mismatch-text-2">

          To access your school account,
        </Text>
        <Button
          style={{
            background: "linear-gradient(180deg, #FFBFB7 0%, #FFA599 100%)",
            marginTop: "16px",
            width: "148px",
            height: "48px",
            borderBlockColor:
            "linear-gradient(180deg, #FFBFB7 0%, #FFA599 100%)",
            borderRadius: "30px",
            fontFamily: "poppins",
            fontWeight: 700,
            size: "16px",
            lineHeight: "24px",
            textColor: "#251465"
          }}
          onClick={() => {
            window.location.href =
            "https://www.coschool.ai/school/aitutor/login";
          }}
          id="login-portal-mismatch-btn">

          Click here
        </Button>
      </Box>);

  };

  const fetchCurriculumId = async () => {
    const { success, data } = await getCurriculum();
    if (success && data?.statusCode === 200) {
      return data?.data?.[0]?.id || "";
    }
    return "";
  };

  const fetchGrades = async (number) => {
    const curriculumId = await fetchCurriculumId();
    const { success, data } = await getGrades(curriculumId);
    if (success && data?.statusCode === 200) {
      let initialData = data?.data?.
      slice().
      reverse().
      reduce((acc, item) => {
        if (item.order > 7 && item.order < 11) {
          acc.push({
            value: item.id,
            label: item.name
          });
        }
        return acc;
      }, []);

      initialData.push({
        value: "other",
        label: "other"
      });
      setGrades(initialData);
      setUserInfo({
        country_code: "+91",
        mobile: number,
        otp: "",
        step: 4,
        toast_keys: [],
        name: ""
      });
    }
  };

  const step_three = () => {
    let otp = userInfoRef?.current.otp;
    let mobile_number = userInfoRef?.current?.mobile;
    let isValid = otp?.trim()?.length == 4;

    return (
      <React.Fragment>
        {/* <div className="right-title-text">Verify your code</div> */}
        <div className="right-header-text" id="step-three-login-verify-otp">
          Verify OTP
        </div>
        <div
          style={{ display: "flex", width: "76%", alignItems: "center" }}
          id="step-three-login-verify-otp-subsection">

          <div
            className="info-text light-weight"
            id="step-three-login-verify-otp-sub-text">
            {`Enter the OTP sent to: `}</div>
          <div
            className="info-text bold-weight"
            id="step-three-login-verify-otp-sent-mobile">

            +91 {mobile_number}
          </div>
        </div>
        <div className="otp-container" id="step-three-otp-container">
          <OTPInput
            value={userInfoRef?.current?.otp}
            onChange={(otp) => {
              setErrorResponse("");
              if (/^\d*$/.test(otp)) {
                handleStateChange("otp", otp);
              }
            }}
            numInputs={4}
            renderInput={(props) =>
            <input
              {...props}
              type="tel"
              inputMode="numeric"
              onKeyDown={(e) => {
                // Handle backspace key
                if (e.key === "Backspace" && e.target.value === "") {
                  e.preventDefault();
                  const inputs = document.querySelectorAll(
                    ".otp-container input"
                  );
                  const currentIndex = Array.from(inputs).indexOf(e.target);

                  if (currentIndex > 0) {
                    // Move focus to previous input
                    inputs[currentIndex - 1].focus();

                    // Update OTP state
                    const newOtp = userInfoRef?.current?.otp.slice(0, -1);
                    handleStateChange("otp", newOtp);
                  }
                }
                // Capture the Enter key event
                else if (e.key === "Enter") {
                  isValid && !isLoader && handleVerifyOtp();
                }
              }} />

            }
            isInputNum={true}
            shouldAutoFocus={true}
            style={otpStyle}
            renderSeparator={<span style={{ paddingRight: "42px" }} />}
            inputStyle={inputStyle} />

        </div>
        <div
          style={{ display: "flex", alignItems: "flex-start", width: "72%" }}
          id="step-three-login-resend-otp-section">

          {seconds > 0 &&
          <div
            style={{
              display: "flex",
              marginTop: "16px",
              marginBottom: "16px"
            }}
            id="step-three-login-resend-timer">

              <Text
              as="b"
              color="#130159"
              textDecoration="underline"
              className={`rensend-text`}
              style={{ marginRight: "auto" }}>

                {seconds > 0 && `Resend `}
              </Text>
              <Text
              as="span"
              color={"#130159"}
              className={`rensend-text `}
              style={{ marginRight: "auto", marginLeft: "4px" }}>

                {seconds > 0 && `${formatTime(seconds)}`}
              </Text>
            </div>
          }

          {seconds == 0 &&
          <div
            className={`rensend-text link`}
            onClick={() => {
              setUserInfo((prev) => {
                return {
                  ...prev,
                  password: "",
                  otp: "",
                  step: 3
                };
              });
              handleSendOtp(true);
            }}
            style={{
              marginLeft: "auto",
              position: "absolute",
              cursor: "pointer"
            }}
            id="step-three-login-resend-option">

              Resend
            </div>
          }
        </div>

        <Button
          className={`btn ${isValid ? "" : "btn-disable"}`}
          onClick={() => {
            isValid && !isLoader && handleVerifyOtp();
          }}
          isLoading={isLoader}
          id="step-three-login-verify-otp-button">

          Verify
        </Button>
        <div className="desclaimer-text" id="step-three-login-waitlist">
          **Class is now in session for Grades 8-10. Join the waitlist.
        </div>
        {isNotEmptyOrNull(errorResponseRef.current) &&
        <div className="error-message" id="step-three-login-verify-otp-error">
            {errorResponseRef.current}
          </div>
        }
      </React.Fragment>);

  };

  const TermsAndConditions = () => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "Top",
          marginLeft: "60px",
          marginRight: "30px",
          marginBottom: "16px"
        }}
        id="login-terms-and-conditions">

        <Box
          width={"24px"}
          height={"21px"}
          borderRadius={"4px"}
          borderWidth={"3px"}
          marginTop={"4px"}
          backgroundColor={"white"}
          borderColor={"#130159"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          onClick={() => {
            setTermsChecked(termsCheckedRef.current === true ? false : true);
          }}
          id="login-terms-and-conditions-checkbox">

          <Box
            width={"80%"}
            height={"80%"}
            borderRadius={"1px"}
            backgroundColor={termsCheckedRef.current ? "#130159" : "#ffffff"}>
          </Box>
        </Box>
        <div
          style={{ color: "#786AC5", marginRight: "10px", marginLeft: "6px" }}>

          {"* "}
        </div>

        <Box id="login-terms-and-conditions-text">
          {"I accept the "}
          <Text
            as="span"
            textDecoration="underline"
            color="#786AC5"
            onClick={handleTerms}>

            Terms and Conditions
          </Text>
          {" and "}
          <Text
            onClick={handleTerms}
            as="span"
            textDecoration="underline"
            color="#786AC5">

            Privacy Policy
          </Text>
        </Box>
      </div>);

  };

  const step_four = () => {
    let nameValue = userInfoRef?.current.name;
    let isValid =
    isNotEmptyOrNull(nameValue.trim()) && isNotEmptyOrNull(selectedGrade);

    return (
      <React.Fragment>
        {/* <div className="right-title-text">Let’s build your classroom!</div> */}
        <div className="right-sub-text" id="step-four-login-sub-text">
          Personalising your learning journey starts now!
        </div>
        <div className="mobile-container" id="step-four-login-mobile-container">
          {/* <div className="country-code">+91</div> */}
          <input
            className="mobile-input"
            placeholder="Name*"
            value={nameValue}
            onKeyDown={(e) => {
              // Capture the Enter key event
              if (e.key === "Enter") {
                isValid && waitListUser();
              }
            }}
            onChange={(e) => {
              const value = e.target.value;
              // Ensure the value is numeric and does not exceed 10 digits
              // if (/^\d{0,10}$/.test(value)) {
              handleStateChange("name", value);
              // }
            }}
            type="text" />

        </div>
        <div className="grade-text" id="step-four-login-grade-text">
          Select your grade
        </div>
        <div
          style={{ overflowX: "auto", width: "76%", marginBottom: "10px" }}
          id="step-four-login-grade-container">

          <RadioGroup className="radio" value={value}>
            <Stack direction="row">
              {grades.map((option) =>
              <div
                key={option?.label}
                style={{ flexDirection: "row", display: "flex", gap: "6px" }}>

                  <Box
                  key={option?.label}
                  width={"20px"}
                  height={"20px"}
                  borderRadius={"10px"}
                  borderWidth={"2px"}
                  marginTop={"4px"}
                  backgroundColor={"white"}
                  borderColor={"#130159"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  onClick={() => {
                    handleChange(option?.label);
                  }}>

                    <Box
                    width={"70%"}
                    height={"70%"}
                    borderRadius={"10px"}
                    backgroundColor={
                    option?.label === value ? "#FFBFB7" : "#ffffff"
                    }>
                  </Box>
                  </Box>
                  <div>{option?.label.replace("Grade", "")}</div>
                </div>
              )}
            </Stack>
          </RadioGroup>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px"
          }}
          id="step-four-login-bottom-container">

          {isOtherSelectedRef.current &&
          <div className="more-grade" id="step-four-login-more-grade">
              More grades will open shortly -{" "}
            </div>
          }
          {isOtherSelectedRef.current &&
          <div
            className="link-text"
            onClick={handleLinkClick}
            style={{ marginLeft: "4px", marginTop: "2px" }}
            id="step-four-login-link-text">

              Back to Home
            </div>
          }
        </div>
        {TermsAndConditions()}

        <Button
          className={`btn ${isValid && termsCheckedRef.current ? "" : "btn-disable"}`
          }
          onClick={() => {
            waitListUser();
          }}
          isLoading={isLoader}
          id="step-four-login-btn">

          Join the waitlist
        </Button>
      </React.Fragment>);

  };

  const handleChange = (newValue) => {
    if (newValue === "other") {
      setIsOtherSelected(true);
      setSelectedGrade("");
    } else {
      setIsOtherSelected(false);
      setSelectedGrade(grades.find((item) => item.label === newValue)?.value);
      console.log("raghavendra" + selectedGrade);
    }
    setValue(newValue);
  };

  const waitListUser = async () => {
    setIsLoader(true);
    if (isNotEmptyOrNull(userInfoRef?.current.name.trim())) {
      if (isNotEmptyOrNull(selectedGrade)) {
        let { success, data, errorMessage } = await sendWaitListUserDetails(
          selectedGrade,
          userInfoRef?.current.name
        );
        setIsLoader(false);
        if (success) {
          let parsedUserDetails = StorageService.getItem("user_details");
          parsedUserDetails =
          typeof parsedUserDetails === "object" ?
          parsedUserDetails :
          JSON.parse(parsedUserDetails);

          let { accessToken, userId, expiresIn, refreshToken, number } =
          parsedUserDetails;
          let details = {};
          let expireMin = expiresIn && expiresIn / 60 || 0;
          expireMin -= 2;
          var newDateObj = moment(new Date()).add(expireMin, "m").toString();
          details.accessToken = accessToken;
          details.refreshToken = refreshToken;
          details.tokenExpire = newDateObj;
          details.userId = userId;
          details.registrationStatus = data?.registrationStatus;
          details.number = number;
          StorageService.setItem("user_details", JSON.stringify(details));
          setIsWaitlisted(true);
        } else {
          // handleShowToast(errorMessage, status.error);
          setErrorResponse(errorMessage, status.error);
          isNotEmptyOrNull(errorResponseRef.current) &&
          <div className="error-message" id="login-waitlist-error-message-1">
              {errorResponseRef.current}
            </div>;

        }
      } else {
        // handleShowToast("Please select grade", status.error);
        setErrorResponse("Please select grade", status.error);
        isNotEmptyOrNull(errorResponseRef.current) &&
        <div className="error-message" id="login-waitlist-error-message-2">
            {errorResponseRef.current}
          </div>;

      }
    } else {
      setIsLoader(false);
      // handleShowToast("Please enter name", status.error);
      setErrorResponse("Please enter name", status.error);
      isNotEmptyOrNull(errorResponseRef.current) &&
      <div className="error-message" id="login-waitlist-error-message-3">
          {errorResponseRef.current}
        </div>;

    }
  };

  const checkRegistrationStatus = async (data, isRegisteredUser) => {
    if (isRegisteredUser) {
      let userData = StorageService.getItem("user_details");
      userData = typeof userData === "object" ? userData : JSON.parse(userData);
      const updatedData = {
        name: userData.firstName,
        phoneNumber: userData.phoneNumber,
        userId: userData.userId,
        registrationStatus: userData.registrationStatus
      };
      const updatedUserData = {
        ...updatedData,
        idToken: userData?.accessToken || userData?.idToken,
        refreshToken: userData.refreshToken,
        tokenExpire: userData.tokenExpire || userData?.expiresIn
      };

      data = updatedUserData;
    }
    let {
      idToken,
      userId,
      name,
      expiresIn,
      tokenExpire,
      refreshToken,
      registrationStatus,
      phoneNumber
    } = data;
    let details = {};
    let expireMin = expiresIn && expiresIn / 60 || 0;
    expireMin -= 2;
    var newDateObj = moment(new Date()).add(expireMin, "m").toString();
    details.accessToken = idToken;
    details.refreshToken = refreshToken;
    details.tokenExpire = isNotEmptyOrNull(expiresIn) ?
    newDateObj :
    tokenExpire;
    details.userId = userId;
    details.registrationStatus = registrationStatus.toString();
    details.phoneNumber = phoneNumber;
    StorageService.setItem("authToken", idToken);
    StorageService.setItem("xUserId", userId);
    StorageService.setItem("name", name);
    StorageService.setItem("user_details", JSON.stringify(details));
    if (details?.registrationStatus === "2") {
      setRegistrationStatus("2");
      if (!isNotEmptyOrNull(grades)) {
        fetchGrades(details?.phoneNumber);
      }
    } else if (details?.registrationStatus === "3") {
      setRegistrationStatus("3");
      setIsWaitlisted(true);
    } else if (details?.registrationStatus === "4") {
      setRegistrationStatus("4");

      let inputObj = {
        mobile_number: details?.phoneNumber
      };
      saveEvent(EVENTS_LIST.OTP_VERIFIED, inputObj);
      const { success, data: userData } = await getUserDetails(
        details?.userId,
        details?.registrationStatus
      );
      // StorageService.setItem(
      //   "user_additional_details",
      //   JSON.stringify(userData?.data)
      // );
      StorageService.setItem(
        "user_additional_details",
        JSON.stringify(userData?.data)
      );
      let schoolId = "";
      // if (success && userData?.data?.schoolId) {
      //   schoolId = userData?.data?.schoolId;
      // }
      if (success && userData?.data?.schoolId) {
        schoolId = userData?.data?.schoolId;
      }

      if (window?.ENV?.IS_STUDENTAPP_MAPPING == "false") {
        setIsTutor(true);
        StorageService.setItem("isTutor", true);
        setSelectedIndex(3);
        setIsStudentAppMapping(false);
      } else {
        if (window?.ENV?.IS_DEFAULT_STANDALONE == "true") {
          setIsTutor(true);
          StorageService.setItem("isTutor", true);
          setSelectedIndex(3);
          setIsStudentAppMapping(true);
        } else {
          setIsTutor(isEmptyOrNull(schoolId) ? true : false);
          StorageService.setItem(
            "isTutor",
            isEmptyOrNull(schoolId) ? true : false
          );
          setIsStudentAppMapping(true);
          setSelectedIndex(isEmptyOrNull(schoolId) ? 3 : 0);
        }
      }
      // StorageService.setItem("isTutor", isTutor);
      //end
      setUserDetails(userData);
      // StorageService.setItem("student_id", userData?.data?.studentId);
      // StorageService.setItem("gradeId", userData?.data?.grade);
      StorageService.setItem("student_id", userData?.data?.studentId);
      StorageService.setItem("gradeId", userData?.data?.grade);
      setCookie("schoolId", schoolId);
      //updating global states...
      setIsAuthenticated(true);
      if (window?.ENV?.IS_DEFAULT_STANDALONE == "true") {
        navigate(`${tutorString}/practice`);
      } else {
        // let userDetails = JSON.stringify(userData?.data);

        // if (
        //   isNotEmptyOrNull(userData?.data?.onBoardingDetails) ||
        //   userData?.data?.isOnBoardingSkipped
        // ) {
        navigate(
          isNotEmptyOrNull(schoolId) ?
          `${urlString}/home` :
          `${tutorString}/practice`,
          {
            replace: true
          }
        );
        // } else {
        //   navigate(`${urlString}/onboarding`, {
        //     replace: true,
        //   });
        // }
      }
    }
  };

  const handleVerifyOtp = async () => {
    setIsLoader(true);
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "verify_otp", {
        event_category: "Click",
        event_label: "Verify OTP",
        value: 1
      });
    }
    let { authId, session, otp } = userInfoRef?.current;
    let { success, data, statusCode, errorMessage, sessionData } =
    await validateOtp(authId, session, otp);
    setIsLoader(false);
    if (success && data?.data?.userId) {
      handleShowToast("OTP Verified Successfully !!", status.success);
      checkRegistrationStatus(data?.data);

      //end
      // setUserDetails(userData);
      // StorageService.setItem("student_id", userData._id);
      // StorageService.setItem("gradeId", userData.grade);
      // navigate(isNotEmptyOrNull(schoolId) ? "/tasks" : "/practice-session");
    } else {
      // handleShowToast(
      //   statusCode === 401
      //     ? isNotEmptyOrNull(errorMessage)
      //       ? errorMessage
      //       : "Invalid OTP"
      //     : "Invalid OTP",
      //   status.error
      // );
      setErrorResponse(
        statusCode === 401 ?
        isNotEmptyOrNull(errorMessage) ?
        errorMessage :
        "Invalid OTP" :
        "Invalid OTP",
        status.error
      );
      setUserInfo((prev) => {
        return {
          ...prev,
          password: "",
          otp: "",
          session: sessionData,
          step: 3
        };
      });
      setSeconds(0);
    }
  };
  const handleSendOtp = async (displayToast) => {
    StorageService.clear();
    storeImage(WifiDownImg);
    setCookie("schoolId", "");
    // setCookie("schoolName", "");
    let { country_code, mobile } = userInfoRef?.current;
    setIsLoader(true);
    let { success, data, statusCode, errorMessage } = await sendOTP(
      country_code,
      mobile,
      window?.ENV?.IS_DEFAULT_STANDALONE == "true" &&
      window?.ENV?.IS_STUDENTAPP_MAPPING == "true"
    );
    setIsLoader(false);
    if (success) {
      let { authId, session } = data?.data || {};
      setSeconds(59);
      setUserInfo((prev) => {
        return {
          ...prev,
          authId,
          session,
          step: 3
        };
      });
      let inputObj = {
        mobile_number: country_code + mobile
      };
      saveEvent(EVENTS_LIST.OTP_SENT, inputObj);
      if (displayToast) {
        handleShowToast("OTP Sent Successfully !!", status.success);
      }
    } else {
      if (statusCode === 403) {
        setUserInfo((prev) => {
          return {
            ...prev,
            step: 5
          };
        });
      } else {
        // handleShowToast(errorMessage, status.error);
        setErrorResponse(errorMessage, status.error);
        isNotEmptyOrNull(errorResponseRef.current) &&
        <div className="error-message">{errorResponseRef.current}</div>;

      }
    }
  };
  let { step } = userInfoRef?.current;
  let titleText, subText;
  if (step === 4) {
    titleText = "You're almost there!";
    subText =
    <>
        Complete your profile to enjoy personalised lessons, instant feedback,
        and a safe space
      </>;

  } else {
    titleText = "Let's start the journey of joyful learning..";
    subText = "Clear your doubts and practice with Vin anytime, anywhere.";
  }

  return (
    <div id="container">
      {!isMobile &&
      <div className="left" id="login-desktop-left-section">
          <VStack className="left-inside" id="login-desktop-left-inside">
            <img
            className="bottom-img"
            id="login-left-bottom-img"
            onClick={() => handleLinkClick()}
            src={Coschool}
            alt="Left Bottom Image" />


            {!isMobile &&
          <div id="login-desktop-title-section">
                <div className="title-text" id="login-desktop-title">
                  {titleText}
                </div>
                <div
              className="sub-text"
              style={{ marginRight: "5px" }}
              id="login-desktop-sub-text">

                  {subText}
                </div>
              </div>
          }
          </VStack>
          <img
          id="login-left-bottom-img"
          className="left-bottom-img"
          src={loginLeftImage}
          alt="Left Bottom Image" />

        </div>
      }
      {isMobile &&
      <div className="toolBar" id="login-mobile-toolbar">
          <img
          className="bottom-img"
          onClick={() => handleLinkClick()}
          src={CoschoolWhite}
          alt="Left Bottom Image"
          id="login-mobile-bottom-img" />

        </div>
      }
      <div className="right" id="login-right-section">
        <div>
          <div className="right-inside-school" id="login-right-inside-school">
            {step == 1 && step_one()}
            {step == 2 && step_two()}
            {step == 3 && step_three()}
            {step == 4 && step_four()}
            {step === 5 && portalMissMatch()}
          </div>
        </div>
        {/* <div className="bottom-items">
           <div className="bottom-div">
             <div className="hide-on-mobile">
               <LottiePlayer
                 options={{
                   loop: true,
                   autoplay: true,
                   animationData: WelcomeLottie,
                   rendererSettings: {
                     preserveAspectRatio: "xMidYMid slice",
                   },
                 }}
               />
             </div>
           </div>
          </div> */}
      </div>
      {isWaitlisted && <Waitlisting isClosable={false} size={"full"} />}
    </div>);

}

export const CustomOTPInput = (props) => {
  const handleInput = (e) => {
    if (!/^\d$/.test(e.nativeEvent.data)) {
      e.preventDefault();
    }
  };

  return (
    <input {...props} type="tel" inputMode="numeric" onInput={handleInput} />);

};